function simulateClickOnEnter(e) {
  if (e.keyCode !== 13) return;
  e.target.click();
}

const DEFAULT_LANGUAGE = 'java';
const PLAIN_TEXT_LANGUAGE = 'text';
const SUPPORTED_LANGUAGES = new Set([
  'apex',
  'html',
  'java',
  'javascript',
  'json',
  'sql',
  'text',
]);

let copyIcon = `<svg style="margin-left: 4px;" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="rgb(75 85 99)" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path></svg>`;
let copiedIcon = `<svg style="margin-left: 4px;" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.40769 9.80773L0.600001 5.97696C0.461539 5.8385 0.461539 5.60773 0.600001 5.46927L1.10769 4.96158C1.24615 4.82312 1.47692 4.82312 1.61539 4.96158L4.47692 7.84619C4.56923 7.9385 4.73077 7.9385 4.82308 7.84619L10.4308 2.19235C10.5692 2.05389 10.8 2.05389 10.9385 2.19235L11.4462 2.70004C11.5846 2.8385 11.5846 3.06927 11.4462 3.20773L4.91539 9.80773C4.77692 9.96927 4.54615 9.96927 4.40769 9.80773V9.80773Z" fill="#2E844A"/>
</svg>`;

function applyCodeCopyBtn() {
  // Skip inline code marked data-no-copy: authors flag these in Badge Builder
  // (via the Nunito font) as snippets that should not get a copy button. (W-22550979)
  // The data-no-copy exclusion is filtered in JS rather than folded into the
  // querySelectorAll argument: a complex :not(pre > code) already consumes the
  // one simple-selector :not() that some engines (e.g. jsdom's nwsapi) accept.
  Array.from(document.querySelectorAll('code:not(pre > code)'))
    .filter((tag) => !tag.hasAttribute('data-no-copy'))
    .forEach((tag) => {
      const codeText = tag.textContent.trim();

      const status = document.createElement('span');
      status.className = 'th-sr-only';
      status.setAttribute('aria-live', 'polite');
      status.setAttribute('role', 'status');
      tag.appendChild(status);

      const cpyBtn = document.createElement('button');
      cpyBtn.innerHTML = window.I18n.t('views.trailhead.shared.general.copy') + copyIcon;
      cpyBtn.setAttribute('aria-label', window.I18n.t('views.trailhead.shared.general.copy'));
      cpyBtn.setAttribute('title', window.I18n.t('views.trailhead.shared.general.copy'));
      cpyBtn.className = 'th-code__button';

      cpyBtn.addEventListener('click', (e) => {
        e.preventDefault();
        cpyBtn.disabled = true;
        navigator.clipboard.writeText(codeText);
        cpyBtn.style.background = '#daf5d9';
        cpyBtn.innerHTML = window.I18n.t('views.trailhead.shared.general.copied') + copiedIcon;
        status.textContent = window.I18n.t('views.trailhead.shared.general.copied');
        setTimeout(() => {
          cpyBtn.disabled = false;
          cpyBtn.style.background = '';
          cpyBtn.innerHTML = window.I18n.t('views.trailhead.shared.general.copy') + copyIcon;
          status.textContent = '';
        }, 3000);
      });

      tag.appendChild(cpyBtn);
    });
}

function normalizeLanguage(rawLanguage, hasExplicitLanguage) {
  const normalized = rawLanguage?.trim().toLowerCase();

  // Language resolution rules:
  // - Blank or missing language metadata defaults to java for backward compatibility.
  // - Unknown explicit language markers (for example, [language: foobar]) are treated
  //   as plain text so we preserve copy/paste intent instead of forcing syntax parsing.
  // - Explicit "text" stays "text", which also suppresses line numbers below.
  if (!normalized) return DEFAULT_LANGUAGE;
  if (SUPPORTED_LANGUAGES.has(normalized)) return normalized;

  return hasExplicitLanguage ? PLAIN_TEXT_LANGUAGE : DEFAULT_LANGUAGE;
}

function detectLanguage(preNode) {
  const dataLanguage = preNode.getAttribute('data-language');
  if (dataLanguage !== null) {
    return normalizeLanguage(dataLanguage, true);
  }

  const codeEl = preNode.querySelector('code[class*="language-"]');
  if (codeEl) {
    const match = codeEl.className.match(/language-([\w-]+)/);
    const extracted = match ? match[1] : '';
    return normalizeLanguage(extracted, true);
  }

  return DEFAULT_LANGUAGE;
}

document.addEventListener('DOMContentLoaded', async () => {
  // Wait for tds-text-block custom element to be defined before creating instances
  await customElements.whenDefined('tds-text-block');

  // Replace pre tags with tds-text-block components
  document.querySelectorAll('pre').forEach(node => {
    const sanitizedSnippet = node.textContent.replace(/\n\n/gi, '\n');
    const language = detectLanguage(node);

    // Create tds-text-block element
    const textBlock = document.createElement('tds-text-block');
    textBlock.setAttribute('language', language);
    if (language !== PLAIN_TEXT_LANGUAGE) textBlock.setAttribute('line-numbers', '');

    // Set content via text node (slots capture child nodes, not textContent property)
    textBlock.appendChild(document.createTextNode(sanitizedSnippet));

    // Replace the pre tag with tds-text-block
    node.parentNode.replaceChild(textBlock, node);
  });

  applyCodeCopyBtn();
});

